export default function UserConsentModel(data) {
    //purposes
    this.title_purposes_th = '';
    this.content_purposes_th = '';
    this.title_purposes_en = '';
    this.content_purposes_en = '';
    //header
    this.title_header_th = '';
    this.content_header_th = '';
    this.title_header_en = '';
    this.content_header_en = '';

    if(data.purposes.length && data.purposes[0].languages.length){
        const consentTh = data.purposes[0].languages[0]
        this.title_purposes_th = consentTh.name,
        this.content_purposes_th = consentTh.description
        if(data.purposes[0].languages.length > 1){
            const consentEn = data.purposes[0].languages[1]
            this.title_purposes_en = consentEn.name,
            this.content_purposes_en = consentEn.description
        }
    }

    if(data.header.length > 1){
        if(data.header[0].language.includes('th')){
            this.content_header_th = data.header[0].description
        }
        if(data.header[1].language.includes('en')){
            this.content_header_en = data.header[1].description
        }
    }
}
